import React from 'react'; 
import FadeIn from "react-lazyload-fadein";
import ScrollAnimation from 'react-animate-on-scroll';
import WithConsumer from '../../context/WithConsumer';
import PageBlock from './PageBlock';
import PageFooter from './PageFooter';
import ScrollToTop from '../global/ScrollToTop';

const Page = ({ context }) => {

	let results = '';
		 
    const posts = () => context.posts;
    const post = posts()[0];
	
	const ctxPageLoaded = () => context.pageLoaded;
    const pageLoaded = ctxPageLoaded();
     
    if (post) {
	    
	    let pageClass = 'c-page-wrapper c-page state-not-loaded c-page-' + post.slug;
		if (pageLoaded == true) {
			pageClass = 'c-page-wrapper c-page state-loaded c-page-' + post.slug;
    	}
    	
	        	
    	if (post.block) {
			
			const background 	= post.background_color;
		    const blocks 		= post.block; 
		    
		    if (pageLoaded == true) {
			    if (blocks[0].background_colour) {
				    if (blocks[0].background_colour =='cream') {
					    document.body.style.backgroundColor = '#b5ada5';
					} else {
						document.body.style.backgroundColor = '#24272a';
					}
			    } else {
				    document.body.style.backgroundColor = '#24272a';
			    }
		    }
		   		    
			if (context.appError){
				return null; 
			} else {
				if (blocks.length === 0){
					return null;
				} else{ 
					
					let pageBlocks = blocks.map(function(block,i){
						return <PageBlock key={i} index={i} background={background}></PageBlock>
					})
					return (
						
						<>
							<div className={pageClass}>
								<ScrollToTop></ScrollToTop>
						
								{pageBlocks}
		
								
								
							</div>
							
							<PageFooter post={post}></PageFooter>
						</>
					)
					
				}
			}
		} else {
			return null;
		}
	} else {
		return null;
	}
};
export default WithConsumer(Page);